import * as types from './mutation-types'
import { convertIntToBoolean } from '@/helpers'

let defaultObject = () => ({
  data: {}
})

export default {
  [types.SET_ARCHIVE] (state, payload) {
    if (payload === null) {
      payload = defaultObject()
    }
    convertIntToBoolean(payload, ['status'])
    state.archive = payload
  },
  [types.SET_ARCHIVES] (state, payload) {
    state.archives = []
    if (payload.data.length > 0) {
      for (let archive of payload.data) {
        convertIntToBoolean(archive, ['status'])
      }
      state.archives = payload.data
    }
    state.pagination = payload.meta.pagination
  }
}
